import translate from '@allesauto/i18n';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

interface UseConsumptionEmissionFootnoteParams {
  emissionValue: string;
  consumptionValue: string;
  wltpAvailable: boolean;
}

export function useConsumptionEmissionFootnote({
  emissionValue,
  consumptionValue,
  wltpAvailable,
}: UseConsumptionEmissionFootnoteParams) {
  const intl = useIntl();

  function isValueAvailable(value: string | number | null | undefined) {
    return (
      value === null ||
      value === '' ||
      value === '0' ||
      value === 0 ||
      value === 'Nicht verfügbar' ||
      value === undefined
    );
  }
  const footnote = useMemo(() => {
    const noConsumptionAndEmissionAvailable =
      isValueAvailable(emissionValue) && isValueAvailable(consumptionValue);

    if (noConsumptionAndEmissionAvailable) {
      return '';
    }
    const translationKey = wltpAvailable
      ? 'ui.PDP.ENVIRONMENT.CO2_EFFICIENCY_ADDITIONAL_INFO_FOOTNOTE_WLTP'
      : 'ui.PDP.ENVIRONMENT.CO2_EFFICIENCY_ADDITIONAL_INFO_FOOTNOTE_NEFZ';

    return translate(intl, translationKey);
  }, [consumptionValue, emissionValue, intl, wltpAvailable]);

  return { footnote };
}
